import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const BecomePartnerCTA = () => (
  <section className="py-8 bg-white border-b border-[#F5F3F0]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-gradient-to-r from-[#2C2C2C] to-[#3C3C3C] rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <p className="text-[#DE92A9] text-xs tracking-[0.2em] uppercase mb-2">FOR VENDORS</p>
          <h3
            className="text-xl md:text-2xl text-white mb-2"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            Want to Be Featured Here?
          </h3>
          <p className="text-white/70 text-sm">
            Join Malta's premier wedding directory and connect with engaged couples.
          </p>
        </div>
        <Link to="/advertise" data-testid="advertise-with-us-cta">
          <Button className="bg-[#DE92A9] hover:bg-[#C9758F] text-white px-6 py-3 text-sm tracking-wider whitespace-nowrap">
            ADVERTISE WITH US <ArrowRight size={16} className="ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

export default BecomePartnerCTA;
